import React, {PureComponent} from 'react';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import {CardCarousel} from '../../components/common/carousel/Carousel';
import {RatioCard} from '../../components/common/carousel/Card';
import {selector} from '../../utils/wdio-selectors';

const has = (key) => (obj) => Boolean(obj[key]);

function buildImageUrl(img) {
    return (res) => img.replace('${templateId}', `carousel-${res}`);
}

function createNewImageCard({
    isMobile,
    url,
    item,
    linkRel,
    index,
    pushHandlerClickData,
}) {
    const {footer, img, link, messageKey, serpLink, title} = item;

    return (
        <RatioCard
            altText={img.altText}
            getImageUrl={buildImageUrl(url)}
            footer={footer}
            fullName={title}
            isMobile={isMobile}
            key={messageKey}
            linkRel={linkRel}
            onClick={pushHandlerClickData(link, index)}
            path={serpLink}
            title={title}
        />
    );
}

export class PropertyTypesComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            payload: [],
        };
    }

    componentDidMount() {
        const {
            basePathPrefix,
            propertyTypes: {items},
        } = this.props;

        if (items) {
            this.props.fetchImagesByTags({
                basePathPrefix,
                items,
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            propertyTypes: currItems,
            moduleLoaded,
            moduleHidden,
        } = this.props;
        const {propertyTypes: prevItems} = prevProps;
        if (currItems !== prevItems) {
            if (
                currItems.items?.length > 0 &&
                currItems.imagesUrls?.length > 0
            ) {
                moduleLoaded('property-types');
            } else {
                moduleHidden('property-types');
            }
        }
    }

    render() {
        const {
            propertyTypes: {title, subtitle, items, imagesUrls},
            isMobile,
            ACTION_LOCATION,
            pushHandlerClickData,
            pushHandleNextData,
            pushHandlePrevData,
        } = this.props;

        if (!items) {
            return null;
        }

        function getImageUrl(item) {
            const match =
                imagesUrls && imagesUrls.find((img) => img.link === item.link);
            return match ? match.url : '';
        }

        const cards = items
            .filter(has('title'))
            .map((item) => ({item, imageUrl: getImageUrl(item)}))
            .map(({item, imageUrl}, index) =>
                createNewImageCard({
                    isMobile,
                    item,
                    url: imageUrl,
                    linkRel: index <= 2 ? '' : 'nofollow',
                    index: index + 1,
                    pushHandlerClickData,
                })
            );

        if (cards.length === 0) {
            return null;
        }

        return (
            <div
                className="container module module--no-padding property-types-ratio-cards"
                data-wdio={selector.propertyTypes}
            >
                <EdapViewTracker
                    eventData={{
                        action_location: ACTION_LOCATION,
                        position_fired: 'top',
                    }}
                    edapEvent={'content_module.presented'}
                />
                <CardCarousel
                    titleMessage={title}
                    subtitleMessage={subtitle}
                    onNextClick={pushHandleNextData}
                    onPreviousClick={pushHandlePrevData}
                >
                    {cards}
                </CardCarousel>
                <EdapViewTracker
                    eventData={{
                        action_location: ACTION_LOCATION,
                        position_fired: 'bottom',
                    }}
                    edapEvent={'content_module.presented'}
                />
            </div>
        );
    }
}

export default PropertyTypesComponent;
